import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { useDefaultFolder } from 'hooks/queries/projects/useDefaultFolder'
import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useCrossPost } from 'common/Prose/components/TextInlineFormatBar/components/CreateNewPost/useCrossPost'
import { useArticlePostPreviewContext } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { Form, Formik, useField } from 'formik'
import Styles from './CrossPostDrawer.module.scss'
import { FilePathFormikField } from 'components/Wizards/FilePathFormikField/FilePathFormikField'
import { Button as BlazeButton } from 'blaze-ui/Button'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Chip } from 'components/Chip/Chip'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { DrawerProps } from 'components/Drawer/Root'

const SubmitButton = ({ isDisabled = false }: { isDisabled?: boolean }) => {
  const [field] = useField('filename')

  return (
    <BlazeButton isDisabled={!field.value || isDisabled} size="xl" type="submit" variant="primary" fullWidth>
      Create Post
    </BlazeButton>
  )
}

export const CrossPostDrawer = observer((props: DrawerProps) => {
  const { drawersStore } = useRootStore()
  const {
    state: { channel: articleChannel },
    scheduledPost,
    almanacFile,
  } = useArticlePostPreviewContext()
  const defaultFolder = useDefaultFolder()
  const { currentFolder } = useCurrentFolderStore()
  const { handleSubmit, validationSchema, channel, setChannel, selectionChannels } = useCrossPost({
    articleChannel,
    scheduledPost,
    onSubmit: () => drawersStore.closeDrawer(),
  })

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight color="var(--light-40)">
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Top>
              <div />
              <Drawer.Title asChild>
                <Heading level={5}>Post to Another Platform</Heading>
              </Drawer.Title>
              <Drawer.Close position="right" />
            </Drawer.Top>
            <Drawer.Container>
              <Formik
                initialValues={{ filename: almanacFile.title || '', project: currentFolder || defaultFolder }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched }) => (
                  <Form>
                    <div className={Styles.newPostSection}>
                      <Heading level={5}>Post Type</Heading>
                      <div className={Styles.channelContainer}>
                        {selectionChannels.map((selectionChannel) => (
                          <Chip
                            deletable={false}
                            key={selectionChannel.key}
                            isSelected={selectionChannel.key === channel}
                            variant="catalogue"
                            size="md"
                            onPress={() => setChannel(selectionChannel.key)}
                          >
                            <ChannelIcon
                              isWhite={selectionChannel.key === channel}
                              size={18}
                              channel={selectionChannel.key}
                            />
                            {selectionChannel.title}
                          </Chip>
                        ))}
                      </div>
                    </div>
                    <Heading level={5}>
                      Name your doc and select a location<div className={Styles.redAsterisk}>*</div>
                    </Heading>
                    <div className={Styles.contentContainer}>
                      <FilePathFormikField
                        inputClassName={Styles.nameInput}
                        locationPickerVariant="tertiary"
                        locationPickerFullWidth
                      />
                    </div>
                    <SubmitButton isDisabled={!channel} />
                  </Form>
                )}
              </Formik>
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
